// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetArticlesListRequestViewModel from '../../viewModel/request/Shop/GetArticlesListRequestViewModel';
import GetCategoriesRequestViewModel from '../../viewModel/request/Shop/GetCategoriesRequestViewModel';
import IsUsernameAvailableForShopRequestViewModel from '../../viewModel/request/Shop/IsUsernameAvailableForShopRequestViewModel';
import ArticleResourcePagingResultViewModel from '../../viewModel/resource/ArticleResourcePagingResultViewModel';
import ArticleResourceViewModel from '../../viewModel/resource/ArticleResourceViewModel';
import BasketResourceViewModel from '../../viewModel/resource/BasketResourceViewModel';
import CategoryListResourceViewModel from '../../viewModel/resource/CategoryListResourceViewModel';
import OrderResourceViewModel from '../../viewModel/resource/OrderResourceViewModel';
import AddressResourceViewModel from '../../viewModel/resource/AddressResourceViewModel';
import UserAccountResourceViewModel from '../../viewModel/resource/UserAccountResourceViewModel';
import AccountLoginRequestViewModel from '../../viewModel/resource/AccountLoginRequestViewModel';
import AccountPasswordResetRequestViewModel from '../../viewModel/resource/AccountPasswordResetRequestViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getArticlesList(request: GetArticlesListRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-articles-list'] ?? 'Articles';
    const response = await service.get<any>(endpointPath, {
      query: {
        language: requestDTO.language,
        categoryId: requestDTO.categoryId,
        searchTerm: requestDTO.searchTerm,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new ArticleResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async getArticleById(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-article-by-id'] ?? 'Articles/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new ArticleResourceViewModel().fromDTO(dto);
  },
  /**  */
  async getByArticleNumber(articleNumber: string, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-by-article-number'] ?? 'Articles/ByArticleNumber/{articleNumber}';
    endpointPath = endpointPath.replace(/\{articleNumber\}/g, `${articleNumber}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new ArticleResourceViewModel().fromDTO(dto);
  },
  /**  */
  async getArticlePreviewImageById(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-article-preview-image-by-id'] ?? 'Articles/{id}/PreviewImage';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as string | undefined;
  },
  /**  */
  async getArticleDetailImageById(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-article-detail-image-by-id'] ?? 'Articles/{id}/DetailImage';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as string | undefined;
  },
  /**  */
  async updateBasket(model: BasketResourceViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-basket'] ?? 'Basket';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const dto = response.data.result;
    return new BasketResourceViewModel().fromDTO(dto);
  },
  /**  */
  async getCategories(request: GetCategoriesRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-categories'] ?? 'Categories';
    const response = await service.get<any>(endpointPath, {
      query: {
        language: requestDTO.language,
      },
      ...config,
    });
    const dto = response.data.result;
    return new CategoryListResourceViewModel().fromDTO(dto);
  },
  /**  */
  async createOrder(model: OrderResourceViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-order'] ?? 'Orders';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as string | undefined;
  },
  /**  */
  async isUsernameAvailableForShop(request: IsUsernameAvailableForShopRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-is-username-available-for-shop'] ?? 'UserAccounts/IsUsernameAvailable';
    const response = await service.get<any>(endpointPath, {
      query: {
        username: requestDTO.username,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as boolean | undefined;
  },
  /**  */
  async registerForShop(model: AddressResourceViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-register-for-shop'] ?? 'UserAccounts/Register';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const dto = response.data.result;
    return new UserAccountResourceViewModel().fromDTO(dto);
  },
  /**  */
  async loginForShop(model: AccountLoginRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-login-for-shop'] ?? 'UserAccounts/Login';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const dto = response.data.result;
    return new UserAccountResourceViewModel().fromDTO(dto);
  },
  /**  */
  async resetPasswordForShop(model: AccountPasswordResetRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-reset-password-for-shop'] ?? 'UserAccounts/ResetPassword';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
  },
});
